import { observer } from "mobx-react";
import { useRef, useState } from "react";
import { PAGE_SIZE_DEFAULT } from "utils/constants";
import { useResizableColumns } from "utils/reportHelper";

// components
import TemplateReportModal from "base/ui/components/Modal/TemplateReportModal";
import Wrapper from "base/ui/components/Wrapper";


// Store - presenter
import {
  productionPlanningPresenter,
  productionPlanningStore,
  reportStore
} from "stores/root_store";

// antd
import { ActionType, ProColumns } from "@ant-design/pro-components";
import {
  Button,
  Form,
  Modal,
  Spin,
} from "antd";
import CustomProTable from "base/ui/components/CustomTable";
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import SaveReportForm from "pages/report/reportComponents/reportForm";
import SearchCollapse from "pages/report/reportComponents/searchCollapse";
import { AiOutlineDownload } from 'react-icons/ai';
import { ProductionPlanningReport } from "services/productionPlanning_services";
import { defaultInitColumn } from "./column";
import SearchForm from "./components/SearchForm";
import ModalDetail from 'pages/report/BC03stuckWarning/ModalDetail';

type SearchModel = {
  paging: {
    pageSize: number;
    pageIndex: number;
    orderBy: string;
    orderByDesc: string;
  };
  khachHang?: string;
  tenTPBTP?: string;
  soWO?: string;
  congDoanSanXuat?: string[];
  mayChuyenSanXuat?: string[];

  trangThaiMES: string[]
}


const initialSearch: SearchModel = {
  paging: {
    pageSize: PAGE_SIZE_DEFAULT,
    pageIndex: 1,
    orderByDesc: "",
    orderBy: "",
  },
  trangThaiMES: ["INPROGRESS"],
}

export function createProductionPlanning() {
  return observer(() => {
    //==========================Loading ===================//
    // Loading của cả trang nếu gửi api thì cho loading
    const [loading, setLoading] = useState(true);
    // loading khi search
    const [isLoading, setIsLoading] = useState(false);
    const [formSearch] = Form.useForm()
    //========================================================//

    // lấy danh sách cho bảng báo cáo
    const [dataTable, setDataTable] = useState<ProductionPlanningReport[]>([]);
    // Thông tin tìm kiếm , phân trang và sort
    const [search, setSearch] = useState<SearchModel>(initialSearch);

    const [modalOpen, setModalOpen] = useState(false);
    const [currentList, setCurrentList] = useState<any[]>([]);

    // =================================================================================//
    // lấy dang sách report
    const getListReport = async (dataSearch: SearchModel) => {
      setIsLoading(true)
      await productionPlanningPresenter.searchReport(productionPlanningStore, dataSearch)
      setIsLoading(false)
      if (productionPlanningStore.dataTable.isSuccess) {
        const data = cloneDeep(productionPlanningStore.dataTable.data)
        setDataTable(data)
        return data
      }
      return [];
    };

    const onShow = () => {
      setModalOpen(true)
    }

    const { defaultColumn } = defaultInitColumn({ onShow, setCurrentList });


    const [columns, setColumns] = useState<ProColumns<ProductionPlanningReport>[]>(defaultColumn);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //====================================================================================//

    //========================================================================================================== //
    //-------------------------------------------MẪU BÁO CÁO-------------------------------------------------//
    //========================================================================================================== //

    const tableRef = useRef<ActionType>();

    // Name data save to localstorage
    const constDataName = "bc-khsx";

    const {
      isResizablePresent,
      resizableColumnSelect,
      columnsState,
      handleColumnsStateChange,
      templateReportModalRef,
      userReports,
      selectedReportId,
      templateReportModalProps,
      setIsResizablePresent,
      handleResize,
    } = useResizableColumns<ProductionPlanningReport>(columns, setColumns, constDataName);


    //=======================XXX========================XXX=========================XXX========================= //

    return (
      <div className="w-full  py-3 px-5">
        <SearchCollapse title="Báo cáo kế hoạch sản xuất">
          <Form
            className="grid grid-cols-2 [&_.ant-form-item]:!mb-2"
            layout="horizontal"
            colon={false}
            initialValues={{
              trangThaiMES: ["INPROGRESS"],
            }}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
            form={formSearch}
            onFinish={(value) => {
              const valueSubmit: any = Object.fromEntries(
                Object.entries(value)
                  .filter(([_, v]) => v !== undefined && v !== '') // Loại bỏ các giá trị undefined
                  .map(([k, v]) => [k, dayjs.isDayjs(v) ? v.format('YYYY-MM-DD') : v]) // Định dạng các đối tượng dayjs
              );
              setSearch({ paging: initialSearch.paging, ...valueSubmit })
              tableRef.current?.reload()
            }}
          >
            <SearchForm />
            <div className="w-full flex justify-center col-span-2">
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
              >
                Chạy báo cáo
              </Button>
            </div>

          </Form>
        </SearchCollapse>
        <Spin spinning={loading}>
          <Wrapper>
            {/* bảng chú thích */}
            <CustomProTable<ProductionPlanningReport>
              columns={columns}
              handleResize={handleResize}
              className={`[&_.ant-pro-table-list-toolbar-container]:!items-end ${loading ? 'opacity-0' : 'opacity-100'} delay-300 duration-300`}
              isResizablePresent={isResizablePresent}
              resizableColumnSelect={resizableColumnSelect}
              request={async (params = {}, sort, filter) => {
                const data = await getListReport({
                  ...search,
                  paging: {
                    ...search.paging,
                    orderBy:
                      Object.values(sort)[0] === "ascend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                    orderByDesc:
                      Object.values(sort)[0] === "descend"
                        ? `${Object.keys(sort)[0].split(",").pop()}`
                        : "",
                  },
                });

                if (Object.values(sort).length) {
                  setSearch({
                    ...search,
                    paging: {
                      ...search.paging,
                      orderBy:
                        Object.values(sort)[0] === "ascend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                      orderByDesc:
                        Object.values(sort)[0] === "descend"
                          ? `${Object.keys(sort)[0].split(",").pop()}`
                          : "",
                    },
                  });
                }
                setLoading(false);
                return {
                  data: data,
                  success: reportStore.BC03Response.isSuccess,
                };
              }}
              scroll={{ x: 2500, y: 500 }}
              dataSource={dataTable}
              actionRef={tableRef} // Gán biến tham chiếu cho instance của bảng
              columnsState={{
                value:
                  Object.keys(columnsState).length > 0
                    ? columnsState
                    : undefined,
                onChange: (newColumnsState) => {
                  handleColumnsStateChange(newColumnsState);
                },
              }}
              rowKey={"key"}
              pagination={{
                pageSize: search.paging.pageSize,
                total: productionPlanningStore.dataTable.paging?.totalCount,
                current: search.paging.pageIndex,
                responsive: true,
                pageSizeOptions: [10, 25, 50, 100],
                showSizeChanger: true,
                position: ["topRight"],
                style: { margin: "10px 0" },
                showTotal: (total, range) =>
                  `Hiển thị ${range[0]}-${range[1]} của ${total} mục`,
                onChange: (page, pageSize) => {
                  setSearch({
                    ...search,
                    paging: {
                      ...search.paging,
                      pageIndex: page,
                      pageSize: pageSize,
                    },
                  });
                },
              }}
              dateFormatter="string"
              toolBarRender={() => [
                <Button
                  size="middle"
                  loading={isLoading}
                  className="bg-primary !flex justify-between items-center gap-2 !px-3 !rounded-sm !py-1"
                  onClick={async () => {
                    setIsLoading(true);
                    await productionPlanningPresenter.exportExcel({ ...search });
                    setIsLoading(false);
                  }}
                  type="primary"
                >
                  <AiOutlineDownload className="block text-base" />
                  <span className="block">Export Excel</span>
                </Button>,
                <SaveReportForm
                  templateReportModalRef={templateReportModalRef}
                  userReports={userReports}
                  selectedReportId={selectedReportId}
                  setIsResizablePresent={setIsResizablePresent}
                />,
              ]}
            />
          </Wrapper>
        </Spin>
        <TemplateReportModal
          ref={templateReportModalRef}
          {...templateReportModalProps}
        />

        <Modal
          title="Thông tin máy/chuyền thực hiện"
          centered
          open={modalOpen}
          okButtonProps={{
            style: {
              display: 'none'
            }
          }}
          cancelButtonProps={{
            style: {
              display: 'none'
            }
          }}
          onOk={() => setModalOpen(false)}

          onCancel={() => setModalOpen(false)}
        >
          <ModalDetail currentList={currentList} />
        </Modal>
      </div>
    );
  });
}
